import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { e as tooltipIcon, f as tooltip, g as tooltipInner } from './parts.js';
import { d as defineCustomElement$1 } from './custom-popper2.js';

const TooltipComponent = /*@__PURE__*/ proxyCustomElement(class TooltipComponent extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.anchorIcon = undefined;
        this.tooltip = undefined;
        this.helpText = undefined;
    }
    show() {
        this.tooltip.classList.add('show');
    }
    hide() {
        this.tooltip.classList.remove('show');
    }
    render() {
        if (!this.helpText) {
            return null;
        }
        return (h("div", { class: "tooltip-container" }, h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "currentColor", class: "bi bi-question-square tooltip-icon", viewBox: "0 0 16 16", ref: (el) => (this.anchorIcon = el), part: tooltipIcon }, h("path", { d: "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" }), h("path", { d: "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94" })), h("custom-popper", { trigger: "hover", placement: "top", anchorRef: this.anchorIcon }, h("div", { class: "tooltip bs-tooltip-top", part: tooltip, role: "tooltip", ref: (el) => (this.tooltip = el) }, h("div", { class: "tooltip-inner", part: tooltipInner }, this.helpText)))));
    }
}, [0, "form-control-tooltip", {
        "helpText": [1, "help-text"],
        "anchorIcon": [32],
        "tooltip": [32]
    }, [[0, "showEvent", "show"], [0, "hideEvent", "hide"]]]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-tooltip", "custom-popper"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, TooltipComponent);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { TooltipComponent as T, defineCustomElement as d };
